import { colors, fontSizes } from '../../../../Components/consts'
import { styled } from '@mui/system'

type InjuryProps = {
  status: string
}

export const InjuryPopper = styled('div')(({ theme }) => ({
  minWidth: 250,
  borderRadius: 15,
  padding: theme.spacing(0.25),
  background: colors.lightGrey,
  '& .closeCon': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    cursor: 'pointer',
    '& .title': {
      marginLeft: 10,
      marginTop: 5,
      fontSize: '1.1rem',
      fontWeight: 700
    },
    '& .close': {
      margin: 3,
      fontSize: '1rem',
      fontWeight: 700
    }
  }
}))

export const InjuryBtn = styled('button')(({ theme }) => ({
  background: 'none',
  border: 'none',
  cursor: 'pointer'
}))

export const Status = styled('div')<InjuryProps>(({ status, theme }) => ({
  fontSize: fontSizes.small,
  fontWeight: 700,
  padding: `1px 3px`,
  borderRadius: 20,
  color:
    status === 'h'
      ? colors.green
      : colors.red,
  background: status === 'h' ? colors.greenOpaque : colors.redOpaque
}))
